import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import alert from '@/pages/components/common/alert';
import './scss/form.scss'

interface initProps {
	history: any,
}

class BindTrader extends React.Component <initProps , any> {
	constructor(props: any) {
		super(props);
		this.state = {
			isSubmit: false,
			trader: '', 
		};
	}

	componentDidMount() {
		function GetQueryString(name: any) {
	        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	        var r = window.location.search.substr(1).match(reg);
	        if (r != null) return r[2];
	        return null;
	    }
	   	const trader = GetQueryString('trader');
	   	this.setState({
	   		trader: trader ? decodeURIComponent(trader) : '',
	   	})
	}

	render() {
		return (
			<div className="page-replacePhone gray-bg">
				<div className="default-form">
					<div className="form-input-warrper">
						<label className="label">我的交易员</label>
						<input type="text" placeholder="请输入交易员" value={this.state.trader} onChange={ (e:any) => this.setState({ trader: e.target.value }) }  />
					</div>
				</div>

				<div className="form-btn-warrrper">
					<button className="form-btn" onClick={() => this.submitForm()}>保存</button>
				</div>
			</div>
		)
	}

	private checkForm() {
		if(this.state.trader.replace(/\s/gi, '') === '') {
			alert.open({
				promptText: '请输入交易员',
			})
			return;
		}
		return true;
	}

	private submitForm() {
		const that = this;
		if(this.state.isSubmit) {
			return ;
		}

		this.setState({
			isSubmit: true,
		}, () => {
			if(that.checkForm()) {
				const data = request({
					method: "post",
					url: `${config.CE}member/info/basic/save`,
					data: {
						trader: this.state.trader,
						updateType: 'trader',
					}
				});

				data.then(r => {
					if(r.code !== 1) {
						alert.open({
							promptText: r.msg,
						})
					}else {
						alert.open({
							promptText: '交易员更改成功！',
							callback: () => {
								that.setState({
									isSubmit: false,
									trader: '',
								},() => that.props.history.push('/userInfo'))
								
							}
						})
					}
				})
			}
		})
	}	
}

export default BindTrader;